<!--
 * @Author: ccx
 * @LastEditors: ccx
 * @Description:
-->
<!-- 项目进展详情页面（包含业务主表信息、流程图、流程意见） -->
<template>
  <div class="progressInfo">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="流程图" name="first"> </el-tab-pane>
      <el-tab-pane label="流程意见" name="second"> </el-tab-pane>
      <el-tab-pane label="流程表单" name="third" v-if="query.name"> </el-tab-pane>
    </el-tabs>
    <div class="flowCanvas">
      <keep-alive>
        <progressComponent
          :attr="flowParams"
          v-if="show && activeName == 'first'"
        ></progressComponent>
      </keep-alive>

      <keep-alive>
        <opininComponent
          :attr="flowParams"
          v-if="show && activeName === 'second'"
        ></opininComponent>
      </keep-alive>
      <keep-alive>
        <component
          :flowParams="flowParams"
          :businessInfo="businessInfo"
          :is="query.name"
          v-if="show && query && activeName === 'third'"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
//注册自定义组件
import customComponents from '@/mixins/customComponents';
export default {
  name: 'progressInfo',
  mixins: [customComponents],
  data() {
    return {
      activeName: 'first',
      cptName: '',
      nodeParams: {},
      flowParams: {
        instanceId: this.query.instanceId
      },
      businessInfo: {},
      show: false,
      flag: false
    };
  },
  props: {
    query: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},

  created() {
    this.getFlowParams();
    // this.getBusinessInfo();
  },

  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
    },
    /**
     * 根据业务key获取业务信息
     */
    getBusinessInfo() {
      if (this.query.businesskey) {
        const params = {
          businessKey: this.query.businesskey
        };
        this.$api
          .formPost('/api/major/query/doGetBusinessInfoByBusinessKey', params)
          .then((res) => {
            if (res.retHead.code == '0000000') {
              this.businessInfo = res.retBody;
            }
          });
      }
    },
    getFlowParams() {
      if (!this.query.instanceId) {
        return;
      }
      const params = {
        instanceId: this.query.instanceId
      };
      this.$api.formPost('/api/flow/history/getFlowParam', params).then((res) => {
        if (res.retHead.code == '0000000') {
          this.flowParams = {
            ...this.flowParams,
            ...res.retBody
          };
          this.flowParams.instanceId = this.query.instanceId;
          this.show = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.progressInfo {
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  .flowCanvas {
    flex-grow: 1;
    position: relative;
  }
}
</style>
